import React from 'react';

import RichText from 'components/RichText';
import { withContent } from 'components/Content';
import Button from 'components/ContentfulFields/Button';

import styles from './deliveryArea.scss';

const CONTENT_KEYS = {
  caption: 'Map Caption',
  map: 'Coverage Map',
  cta: 'Start Delivery Order',
};

const DeliveryArea = ({ content }) => {
  const { map, caption, cta } = content;
  if (!caption || !map) return null;

  const { richText } = caption.fields;
  const { file, description } = map.fields;

  return (
    <section className={styles.deliveryArea}>
      <figure className={styles.wrapper}>
        <figcaption className={styles.caption}>
          <RichText richText={richText} styles={styles} />
        </figcaption>
        <img
          className={styles.map}
          src={`${file.url}?fm=webp`}
          alt={description || ''}
          aria-hidden="true"
        />
        <Button className={styles.cta} document={cta} />
      </figure>
    </section>
  );
};

export default withContent(CONTENT_KEYS)(DeliveryArea);
